export const wallets = {
  WALLETS_HEADING: "المعاملات المالية الخاصة بك",
  PAYMENT_CUSTOMER_PAY_BUYER: "  تم دفع قيمة المعاملة   ",
  PAYMENT_CUSTOMER_PAY_BUYER_TO: " الى ",
  PAYMENT_CUSTOMER_PAY_BUYER_SUB: "المبلغ محجوز لحين انتهاء المعاملة ",
  SAR: " ريال ",
  PAYMENT_CUSTOMER_REFUND: " تم  تحويل ",
  PAYMENT_CUSTOMER_REFUND_TEXT: " ريال قيمه المعاملة ",
  PAYMENT_CUSTOMER_REFUND_TEXT_ACCOUNT: " الى حساب ",
  PAYMENT_RELASE_BUYER: "تم إرجاع قيمة المعاملة ",
  PAYMENT_RELASE_BUYER_ACCOUNT: " لحسابك",
  PAYMENT_RELASE_BUYER_SUB: " قمنا برد المبلغ لحساب المشترى   ",
  PAYMENT_SELLER_CUSTOMER_PAY_BUYER: " تم دفع قيمة المعاملة   ",
  PAYMENT_SELLER_CUSTOMER_PAY_BUYER_TO: " بواسطة ",
  SELLER_PAYMENT_CUSTOMER_REFUND: "تم ايداع ",
  SELLER_PAYMENT_CUSTOMER_REFUND_TEXT: " ريال قيمة المعاملة ",
  SELLER_PAYMENT_CUSTOMER_REFUND_TEXT_ACCOUNT: " فى حسابك البنكى ",
  SELLER_PAYMENT_RELASE_BUYER: "تم إرجاع قيمة المعاملة ",
  SELLER_PAYMENT_RELASE_BUYER_TO: " لحساب ",
  SELLER_PAYMENT_RELASE_BUYER_SUB: " قمنا برد المبلغ لحساب المشترى   ",
  ALL_TRANS: "  كل المعاملات ",
  BALANCE: "رصيد وفى",
};

export const walletsTypes = {
  CUSTOMER_PAY: "CUSTOMER_PAY",
  RELEASE_TO_PROVIDER: "RELEASE_TO_PROVIDER",
  CLOSE_RELEASE_TO_PROVIDER: "CLOSE_RELEASE_TO_PROVIDER",
  REFUND_CUSTOMER: "REFUND_CUSTOMER",
};
